/**
 * 사용자 수동 조준 타겟 토글 (순수 — Phaser 비의존).
 *
 * 사용자가 벽돌을 클릭하면 그 블럭을 강제 조준 대상으로 삼고, 같은 블럭을 다시 클릭하면 해제한다.
 * 해제(또는 그 블럭 파괴)되면 selectAimTarget의 forcedId가 null이 되어 "가장 가까운 순" 자동 조준으로
 * 복귀한다. 클릭 결정 로직만 여기 분리해 selectAimTarget(거리/hysteresis)와 책임을 나눈다.
 */

/**
 * 현재 수동 타겟과 클릭한 블럭 id로 다음 수동 타겟을 결정한다.
 *  - 같은 id 재클릭 → null(해제, 자동 조준 복귀).
 *  - 다른 id 클릭 → 그 id로 전환.
 *
 * @param current - 현재 수동 조준 중인 블럭 id(`"gridX,gridY"`) 또는 null.
 * @param clickedId - 방금 클릭된 블럭 id.
 * @returns 다음 수동 타겟 id 또는 null(해제).
 */
export function toggleTarget(current: string | null, clickedId: string): string | null {
  return current === clickedId ? null : clickedId;
}
